import HomePage from './HomePage.js';
import AuthContext from '../../context/AuthContext.js';
import WithGASetup from '../../components/WithGASetup';

export default WithGASetup(HomePage, AuthContext);
